<!--<div #testWrapper class="breadcrumbs-wrapper breadcrumbs-wrapper-test">-->
<div #testWrapper [class.hide]="hideTest" class="breadcrumbs-wrapper breadcrumbs-wrapper-test">
  <div class="breadcrumbs">
    @for (item of pageData().breadcrumbs; track item) {
      <a [href]="item.sourceUrl | addFr">
        <span class="item text"> {{ item.shortTitle || item.title }} </span>
      </a>
      <i class="icon-CaretRight"></i>
    }
    <span class="item text last"> {{ pageData().shortTitle || pageData().title }} </span>
  </div>
</div>

@if (pageData().breadcrumbs && pageData().breadcrumbs.length >= 1) {
  <div #brWrapper class="breadcrumbs-wrapper" [class.hide]="!hideTest">
    <div class="breadcrumbs">
      @if (!showShortBreadcrumbs) {
        @for (item of pageData().breadcrumbs; track item) {
          <a [href]="item.sourceUrl | addFr">
            <span class="item text"> {{ item.shortTitle || item.title }} </span>
          </a>
          <i class="icon-CaretRight"></i>
        }
        <ng-container *ngTemplateOutlet="siblingsDropdown"></ng-container>
      }
      @if (showShortBreadcrumbs) {
        <div class="button-wrapper">
          <div class="button" (click)="toggleBreadcrumbs($event)"><i
            class="ignore icon-DotsThreeVertical"></i>
          </div>
          <div class="drop-list" (clickOutside)="clickOutside($event)" [class.hide]="!showDropdown">
            @for (item of pageDataBreadcrumb(); track item; let isLast = $last) {
              @if (!isLast) {
                <a [href]="item.sourceUrl | addFr">
                  <div class="drop-list-item">{{ item.shortTitle || item.title }}</div>
                </a>
              }
            }
          </div>
        </div>
        <i class="icon-CaretRight"></i>


        @for (item of pageDataBreadcrumb(); track item; let isLast = $last) {
          @if (isLast) {
            <a #lastElem [href]="item.sourceUrl | addFr">
              <span class="item text"> {{ item.shortTitle || item.title }} </span>
            </a>
            <i class="icon-CaretRight"></i>
          }
        }
        <ng-container *ngTemplateOutlet="siblingsDropdown"></ng-container>
      }
    </div>
  </div>
} @else {
  <div #brWrapper class="breadcrumbs-wrapper" [class.hide]="!hideTest">
    <div class="breadcrumbs">
      <ng-container [ngTemplateOutlet]="siblingsDropdown"></ng-container>
    </div>
  </div>
}


<ng-template #siblingsDropdown>

  @if (pageDataSiblings().length && isMobile) {

    <div class="button-wrapper button-wrapper-siblings" (click)="toggleSiblings($event)">

      <div class="button">
        <div class="item text"> {{ pageData().shortTitle || pageData().title }}</div>
        <i class="ignore icon-CaretDown"></i>
      </div>
      <div class="drop-list-siblings" [class.is-right]="useRightPosition"
           (clickOutside)="clickOutside($event)"
           [class.hide]="!showDropdownSiblings">
        <div class="scroll-wrapper">
          @for (item of pageDataSiblings(); track item; let isLast = $last) {
            <a [href]="item.sourceUrl | addFr">
              <div class="drop-list-item item text ">{{ item.shortTitle || item.title }}</div>
              <i class="icon-CaretRight"></i>
            </a>
          }
        </div>
      </div>
    </div>

  } @else {
    <div class="justText item text last"> {{ pageData().shortTitle || pageData().title }}</div>
  }
</ng-template>
